/* eslint-disable */
import React, { useState, useEffect, memo, useRef } from 'react';
import { Layout, message, Icon, Tooltip, Badge, Modal } from 'antd';
import axios from '@/utils/request';
import PopUpNoticeInfo from './popup/popupMessage';
import { get } from 'lodash';
import { getKeyFormArray } from '@/utils/utils';
import { getHasPermissionKey } from './request/request';

const { Header } = Layout;

// const importantLogo ="data:image/png;base64,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";
const importantLogo =
  'data:image/png;base64,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';

const HeaderComponent = (props) => {
  const { menuList = [] } = props;
  const [username, setUsername] = useState('');
  const [messageVisible, setMessageVisible] = useState(false);
  const [messagePermission, setMessagePermission] = useState(false);
  const [popupNotice, setPopupNotice] = useState('');
  const [noticeLoading, setNoticeLoading] = useState(false);
  const [noticePage, setNoticePage] = useState(false);
  const [unReadNum, setUnReadNum] = useState(0);

  const userNo = window.localStorage.getItem('kiwi.saas.userNo');
  const timerNotice = useRef();

  const appLogout = () => {
    axios.post('/saas-auth/open/logout').then((res) => {
      if (res.data.code === 1) {
        sessionStorage.removeItem('kiwi.saas.token');
        localStorage.clear();

        for (let i = 0; i < localStorage.length; i++) {
          if (localStorage.key(i) !== 'modal-local-storage-app-id') {
            localStorage.removeItem(localStorage.key(i));
          }
        }

        message.success('退出成功');

        setTimeout(() => {
          window.location.href = '/login';
        }, 500);
      } else {
        message.error(res.data.message);
      }
    });
  };

  // 判断是否有消息权限
  const getMessagePermissionKey = async () => {
    const cindex = getKeyFormArray(menuList, 'message_manage');
    if (cindex >= 0) {
      const data = await getHasPermissionKey({ groupKey: ['message_manage'] });
      const bool = get(data, 'groupKeyPermit.message_manage', false);
      if (!bool) {
        setMessagePermission(false);
      } else {
        setMessagePermission(true);
      }
    } else {
      setMessagePermission(false);
    }
  };

  // 未读消息
  const getUnReadMessage = () => {
    axios
      .post('/saas-auth/message/getUnreadNum')
      .then((res) => {
        let data = res.data;
        if (data.code === 1) {
          setUnReadNum(data?.data?.unreadNum);
          if (data?.data?.unreadNum > 0) {
            localStorage.setItem('kiwi.saas.raderNum', data?.data?.unreadNum);
          } else {
            localStorage.removeItem('kiwi.saas.raderNum');
          }
        }
      })
      .catch((err) => {});
  };

  // 用户详情
  const getUsername = () => {
    axios
      .get('/saas-auth/user/me')
      .then((res) => {
        let data = res.data;
        if (data.code === 1) {
          window.adminUserNo = Object.freeze(data.data?.userNo);
          window.enterpriseType = Object.freeze(data.data?.type);
          window.currentAccount = Object.freeze(data.data?.account);
          setUsername(data.data.account);
          props.setVersion(data.data?.version);
        }
      })
      .catch((err) => {});
  };

  // 消息通知已读设置
  const getPopupMessage = () => {
    if (!(userNo === 'kiwi_admin' || userNo === '20171887')) {
      setNoticeLoading(true);
      axios
        .post('/saas-auth/message/getPopupMessage')
        .then((res) => {
          if (res.data.code === 1) {
            const data = get(res, 'data.data', '');
            if (data) {
              setNoticeLoading(false);
              setPopupNotice(data);
              setMessageVisible(true);

              axios
                .post('/saas-auth/message/redeMessage', { id: data?.id })
                .then(async (res) => {})
                .catch((err) => {});
            }
          }
        })
        .catch((err) => {
          setNoticeLoading(false);
        });
    }
  };

  useEffect(() => {
    (async () => {
      let localStorage = window.localStorage.getItem('kiwi.saas.token');
      if (localStorage) {
        await getUsername();
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (menuList && menuList.length) {
        await getMessagePermissionKey();
      }
    })();
  }, [menuList]);

  useEffect(() => {
    (async () => {
      if (messagePermission && menuList.length) {
        // 消息通知已读设置
        await getPopupMessage();

        let bool = false;
        if (props.history.location.pathname.indexOf('/admin/notice/user') !== -1) {
          bool = true;
          setNoticePage(bool);
          window.localStorage.removeItem('kiwi.saas.notice');
          timerNotice.current = setInterval(() => {
            // if (!(userNo === 'kiwi_admin' || userNo === '20171887')) {

            // }
            const temp = localStorage.getItem('kiwi.saas.raderNum');
            if (temp) {
              setUnReadNum(temp);
            } else {
              setUnReadNum(0);
            }
          }, 2000);
        } else {
          clearInterval(timerNotice.current);
          bool = false;
          setNoticePage(bool);
          window.localStorage.setItem('kiwi.saas.notice', Math.random());
        }

        if (!bool && window.localStorage.getItem('kiwi.saas.notice')) {
          await getUnReadMessage();
        }
      }
    })();
  }, [props.history.location.pathname, messagePermission, menuList]);

  const downloadWord = () => {
    window.location.href = '/download/signTool?doc=1';
  };

  const openMessage = (e) => {
    e.stopPropagation();
    e.preventDefault();

    const { location } = props;
    if (location.pathname === '/admin/notice/user') return;

    props.history.push({
      pathname: '/admin/notice/user',
    });
  };

  const handelClose = async () => {
    setMessageVisible(false);
    await getUsername();
    // axios
    //   .post('/saas-auth/message/redeMessage', { id: popupNotice?.id })
    //   .then(async res => {
    //     const id = get(res, 'data.code', '');
    //     if (id) {
    //       setMessageVisible(false);
    //       await getUsername();
    //     }
    //   })
    //   .catch((err) => {
    //     setNoticeLoading(false)
    //   });
  };

  let isPrivate = false,
    customTitles = '移动应用安全管理平台',
    hideInfos = false,
    webConfig = window.webConfig,
    customLogoImg = decodeURIComponent(webConfig.logo);
  let webSite = webConfig.site;
  let qqLink = webConfig.qqLink;
  const { xf: { isPrivateServer = false, title = '-', hideInfo = false, logo = '' } = {} } = window.webConfig;
  isPrivate = isPrivateServer;
  customTitles = webConfig.title || '';
  hideInfos = hideInfo;
  let style = { height: '50px', lineHeight: '50px' };

  return (
    <Header className="header" style={style}>
      {isPrivate && hideInfos ? (
        <div className="logos">
          <a href="/encrypt/android">
            <img style={{ height: '15px' }} src="/images/private_logo.png" />
          </a>
          &nbsp;
          <span
            style={{
              fontSize: '14px',
              fontWeight: 'blod',
              marginLeft: '4px',
            }}
          >
            {customTitles}
          </span>
        </div>
      ) : (
        <div className="logos">
          <span>
            <img src={customLogoImg || importantLogo} className="uvec-img-logo" style={{ height: '32px' }} />
          </span>
          &nbsp;
          <span className="min-title">{customTitles}</span>
        </div>
      )}

      <div className="user-mine" style={{}}>
        {username && !props.isDefault ? (
          <em onClick={appLogout}>
            <i className="pri-out private-icon" />
            <span>退出</span>
          </em>
        ) : null}

        {props.isDefault ? null : (
          <em
            className="user-list"
            onClick={
              username
                ? () => {
                    window.location.href = '/user/info';
                  }
                : () => {
                    props.history.push('/login/');
                  }
            }
          >
            <i className="private-icon pri-user" />
            <span>{username || '登录'}</span>
          </em>
        )}
        {username && !props.isDefault && messagePermission ? (
          <em>
            <a className="help-link" href="#" onClick={openMessage}>
              {/* 
              {
                userNo === 'kiwi_admin' || userNo === '20171887' ? (
                  <Badge count={0} offset={[10, 0]}>
                    <Icon type="message" />
                    消息
                  </Badge>
                ) : (
                  <Badge count={unReadNum} offset={[10, 0]}>
                    <Icon type="message" />
                    消息
                  </Badge>
                )
              }
              */}
              <Badge count={unReadNum} offset={[10, 0]}>
                <Icon type="message" />
                消息
              </Badge>
            </a>
          </em>
        ) : null}

        {isPrivate ? null : webSite ? (
          <em>
            <a className="help-link" href={webSite} target="_blank">
              <Icon type="home" />
              访问官网
            </a>
          </em>
        ) : null}
        {isPrivate ? (
          <Tooltip placement="bottomRight" title="电话：028-8317-7117">
            <em>
              <Icon type="phone" style={{ fontSize: '16px', lineHeight: '52px' }} />
              问题反馈
            </em>
          </Tooltip>
        ) : null}

        {isPrivate && !props.isDefault ? (
          <em>
            <a href="/download/signTool" style={{ color: '#bababa' }}>
              <Icon type="download" />
              加固助手
            </a>
          </em>
        ) : null}
        {/* qq咨询链接 */}
        {qqLink ? (
          <a href={webConfig.qqLink} target="_black" id="officeWebEnterprise">
            <i className="pri-qq private-icon" />
            在线咨询
          </a>
        ) : null}
      </div>

      <Modal visible={messageVisible} title="消息详情" footer={null} onCancel={handelClose}>
        <PopUpNoticeInfo handelClose={handelClose} noticeLoading={noticeLoading} noticeInfo={popupNotice} />
      </Modal>
    </Header>
  );
};
export default memo(HeaderComponent);
